module.exports = __webpack_public_path__ + "img/popup-bg.8b83b902.png";